import SideActionBase from '@/plugin/sideActions/sideActionBase';
import { Component } from 'vue-property-decorator';

@Component
export default class CO2ActionComponent extends SideActionBase<any> {
    public setCalculatedValue(e): void {
        this.finished(e);
    }
}
